import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import logo from '../images/KhetBazaar_logo_new_design.png';
import profileImg from '../images/profile.png';
import('../css/Navbar.css');




const NavbarComponent = () => {
    const navigate = useNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [deferredPrompt, setDeferredPrompt] = useState(null)
    const [isInstallable, setIsInstallable] = useState(false)
    const menuRef = useRef(null);
    const profileRef = useRef(null);

    // Get user data from localStorage with proper type checking
    const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const user = (() => {
        try {
            const userData = JSON.parse(localStorage.getItem('user'));
            return userData || { name: 'Guest', profileImg: 'default-avatar.png' };
        } catch {
            return { name: 'Guest', profileImg: 'default-avatar.png' };
        }
    })();

    // Install Button

    const handleInstallClick = async () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;
            if (outcome === 'accepted') {
                console.log('App installed');
            }
            setDeferredPrompt(null);
            setIsInstallable(false);
        }
    };


    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setIsInstallable(true);
        };

        window.addEventListener('beforeinstallprompt', handler);
        return () => window.removeEventListener('beforeinstallprompt', handler);
    }, []);

    // Close menus when clicking outside
    // console.log("Navbar is loaded outside the useef")

    useEffect(() => {
        // console.log("Navbar is loaded")
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setIsProfileOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Close menu when window is resized
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 768) {
                setIsMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleLogout = () => {
        localStorage.clear();
        setIsProfileOpen(false);
        setIsMenuOpen(false);
        navigate('/login');
    };

    const handleProfileNavigation = (path) => {
        setIsProfileOpen(false);
        setIsMenuOpen(false);
        navigate(path);
    };

    const navItems = [
        { path: '/landlist', label: 'Buy Land', className: 'buy-sell' },
        { path: '/register-land', label: 'Sell Land', className: 'buy-sell' }
    ];

    const profileMenuItems = [
        { label: 'My Profile', path: '/profile' },
        // { label: 'My Wallet', path: '/wallet' },
        { label: 'My Listings', path: '/listings' },
        { label: 'List Your Land', path: '/register-land' },
        // { label: 'Seller Plans', path: '/seller-plans' },
        // { label: 'Buyer Plans', path: '/buyer-plans' }
    ];

    return (
        <nav className="navbar" ref={menuRef}>
            <div className="navbar-logo">
                <NavLink to="/home" className="logo-link">
                    <img id="logo" src={logo} alt="KhetBazaar Logo" />
                    <h2 className="header">
                        <span className="khet">KHET</span>
                        <span className="bazaar">BAZAAR</span>
                    </h2>
                </NavLink>
                {isInstallable && (
                    <button onClick={handleInstallClick} className="install-button">
                        📲 Get App
                    </button>


                )}

                <button
                    className="menu-icon"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                    aria-label="Toggle menu"
                >
                    <span className={`menu-bar ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`menu-bar ${isMenuOpen ? 'open' : ''}`}></span>
                    <span className={`menu-bar ${isMenuOpen ? 'open' : ''}`}></span>
                </button>
            </div>

            <div className={`navbar-content ${isMenuOpen ? 'active' : ''}`}>
                <ul className="navbar-links">
                    {navItems.map((item, index) => (
                        <li key={index}>
                            <NavLink
                                to={item.path}
                                className={({ isActive }) =>
                                    isActive ? `${item.className} active` : item.className
                                }
                            >
                                {item.label}
                            </NavLink>
                        </li>
                    ))}

                    {isLoggedIn ? (
                        <li className="navbar-profile" ref={profileRef}>
                            <button
                                className="profile-button"
                                onClick={() => setIsProfileOpen(!isProfileOpen)}
                            >
                                <span className="profile-name">{user.name}</span>
                                <img
                                    src={user.profileImg || profileImg}
                                    alt="Profile"
                                    className="profile-avatar"
                                />
                            </button>

                            <div className={`dropdown-menu ${isProfileOpen ? 'active' : ''}`}>
                                {profileMenuItems.map((item, index) => (
                                    <button
                                        key={index}
                                        className="dropdown-item"
                                        onClick={() => handleProfileNavigation(item.path)}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                                <hr className="dropdown-divider" />
                                <button
                                    className="dropdown-item logout"
                                    onClick={handleLogout}
                                >
                                    Logout
                                </button>
                            </div>
                        </li>
                    ) : (
                        <>
                            <li>
                                <NavLink to="/login" className="navbar-button-login">
                                    Login
                                </NavLink>
                            </li>
                            <li>
                                <NavLink to="/signup" className="navbar-button-signup">
                                    Sign up
                                </NavLink>
                            </li>
                        </>
                    )}
                </ul>
            </div>
        </nav>
    );
};

export default NavbarComponent;